import type { Prototype } from "../prototype-types";

export const gabeKelleyPrototypes: Prototype[] = [
  {
    id: "product-tour",
    name: "Product Tour",
    path: "/gk/product-tour",
    description:
      "Guided product tour on the brand portal homepage, built on the Slate Popover. Two concepts: (1) flashing dot indicator behind the popover pointer, (2) spotlight mask that dims everything except the anchored element.",
    owner: "Gabe",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b4d8ae01ad079ea23c663e12f450b8361aa10aa8edc7e8a7aea864c5272b47f8.png",
  },
  {
    id: "v2-toolbar",
    name: "V2 Toolbar",
    path: "/gk/v2-toolbar",
    description:
      "Vertical icon toolbar with flyout panels for info, variants, comments, and more. Draggable, collapsible, works on any prototype. Cloned from John Intrater's Variant Switcher V2.",
    owner: "Gabe",
    createdAt: "2026-04-17",
    lastUpdated: "2026-04-27",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2659d21082bd347f6d6b027de8519d5613fccb96f19c85ba038ddc4d99f8f9aa.png",
  },
  {
    id: "combobox",
    name: "Combobox",
    path: "/gk/combobox",
    description:
      "Interactive combobox prototype with type-to-filter and configurable open/close animation. Based on Figma design (-GK–Combobox).",
    owner: "Gabe",
    createdAt: "2026-02-03",
    lastUpdated: "2026-04-27",
    surfaceArea: "Other",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a7ed6feffe56327b7a15571e8ee102998b2efac934eae3768cb67d8686cd89a1.png",
    creationTool: "cursor",
  },
  {
    id: "gk-playground-1-0-demo-page",
    name: "Playground 1.0 Demo Page",
    path: "/gk/playground-1-0-demo-page",
    description: "",
    owner: "Gabe Kelley",
    createdAt: "2026-05-05",
    lastUpdated: "2026-05-05",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6579740be8978ec5275830b66f9e66ab8cde40058b69fe0624b3c27c74fe03e5.png",
    creationTool: "claude-code",
  },
];
